define('shoptheme/components/customer/b2e/popup',[
	"jquery",
	"cartware/components/_base",
	"cartware/jquery/bem",
	"text!shoptheme/templates/magnific-popup/default.html",
	"magnific-popup"
], function(
	$,
	Component,
	BEM,
	PopupHtml
) {

	var popupTemplate = null;

	return Component.create({
		blocks:	null,

		$init: function() {
			var self = this;
			this.block = BEM.block('b2e-customer-notice');
			this.form = window.b2eConsentForm;

			var legalTextClassName = BEM.buildElementClassname('b2e-customer-notice', 'wrapper'),
				legalBlock = this.block.find('.' + legalTextClassName);

			if (legalBlock.length) {
				this._showMessage('', legalBlock.html());
				legalBlock.remove();
			}
		},

		_renderPopup: function(data) {
			if (null === popupTemplate) {
				popupTemplate = _.template(PopupHtml);
			}

			return popupTemplate(data);
		},

		_showMessage: function(title, message) {
			var root = this;
			$.magnificPopup.open({
				items: {
					src: this._renderPopup({
						title: title,
						body: message
					}),
					type: 'inline',
				},
				callbacks: {
					open: function(a,b,c) {
						var self = this;
						var form = this.contentContainer.find('#b2e_consent_form');
						var b2eConsentForm = new VarienForm('b2e_consent_form');
						form.on('submit', function (e) {
							e.preventDefault();
							if (b2eConsentForm.validator.validate()) {
								root.setCookie('should_agree_b2e', 0);
								self.close();
							}
						})
					},
					close: function() {
					}
				},
				modal: true
			});
		},

		setCookie: function(name, value, days) {
			var expires = "";
			var domainName = window.location.hostname;
			if (days) {
				var date = new Date();
				date.setTime(date.getTime() + (days*24*60*60*1000));
				expires = "; expires=" + date.toUTCString();
			}
			document.cookie = name + "=" + (value || "")  + expires + "; path=/; domain=." + domainName + ";";
		}
	});
});
